import { render, staticRenderFns } from "./companySettingsPage.vue?vue&type=template&id=31b04ec9&"
import script from "./companySettingsPage.vue?vue&type=script&lang=ts&"
export * from "./companySettingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports